import { settings } from '../settings';
import ReactGA from 'react-ga';

const gaAvailable = Boolean(settings.googleAnalyticsCode);

const initialize = () => {
  if (gaAvailable) {
    ReactGA.initialize(settings.googleAnalyticsCode, {
      standardImplementation: true,
      gaOptions: {
        siteSpeedSampleRate: 40,
      },
    });
  }
};

const event = (args: ReactGA.EventArgs) => {
  if (gaAvailable) {
    ReactGA.event(args);
  } else {
    console.log(
      `Tracking event occurred (GA not available): ${JSON.stringify(args)}`
    );
  }
};

const timing = (args: ReactGA.TimingArgs) => {
  if (gaAvailable) {
    ReactGA.timing(args);
  } else {
    console.log(`Tracking timing (GA not available): ${JSON.stringify(args)}`);
  }
};

const pageview = (path: string) => {
  if (gaAvailable) {
    ReactGA.set({ page: path });
    ReactGA.pageview(path);
  }
};

const exportedObject = {
  initialize,
  event,
  timing,
  pageview,
};

export default exportedObject;
